import { api } from '$app/api';

export const getAllGarages = async (all = true, overwriteFranceCnD = false) => {
  let allGarages = [];
  let keepTotal = 1;
  let page = 0;

  // We limit the page loop to 100 so that it doesn't
  // go into a infitite loop in case something goes wrong.
  while (allGarages.length < keepTotal && page < 100) {
    // EG response:
    // garages: [...]
    // page : 0
    // pageSize : 750
    // total : 752
    const params = { all, page };
    const { data } = await api.get('/garages', { params });
    const { garages, total } = data;

    // In france we don't have true GarageC&D, and we use this hack to map to Fixter C&D
    // Talk with Catalin C and Muhan
    // https://www.notion.so/fixter/Open-up-Fixter-C-D-to-all-in-FR-a4feac59e71b47b8b31ad6d163d2bb49
    const mappedGarages = garages.map((garage) => {
      if (
        overwriteFranceCnD &&
        garage.segment === 'FIXTER-FR' &&
        garage?.deliveryOptions[0]?.deliveryOption === 'GarageC&D'
      ) {
        garage.deliveryOptions[0].deliveryOption = 'Fixter';
      }
      return garage;
    });

    keepTotal = total;
    page += 1;
    allGarages = [...allGarages, ...mappedGarages];
  }

  return allGarages;
};
